import { QueryParams } from "@/models/query-params.model";
import { Status } from "@/models/stats.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, map } from "rxjs";

export class StudentsService {
  constructor(
    private _stats = new StatsRest(),
    private _generics = new GenericsUtils()
  ) {}

  students$ = new BehaviorSubject([]);
  students = this.students$.asObservable();

  getStudentsFromCourse(courseId: string, params: QueryParams): void {
    this._stats
      .getStudentsFromCourse(courseId, params)
      .pipe(
        map((e) => {
          e.content.forEach((item) => {
            item.courseStudentStatus = this.remakeObjectStatus(
              item.courseStudentStatus
            );
            item.studentStatus = this.remakeObjectStatus(item.studentStatus);
            item.averageQuiz =
              item.averageQuiz == 0 ? " - " : String(item.averageQuiz);
            item.failedQuizzes =
              item.failedQuizzes == 0 ? " - " : item.failedQuizzes;
            item.lastAccess = item.lastAccess
              ? this._generics.getDate(item.lastAccess)
              : "Não acessou";
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.students$.next(response);
        },
      });
  }

  getStatus(status: string): string {
    if (status == Status.ACTIVE) {
      status = GenericsUtils.translateI18n(
        "stats.course.students.status.active"
      );
    } else if (status == Status.INACTIVE) {
      status = GenericsUtils.translateI18n(
        "stats.course.students.status.inactive"
      );
    } else if (status == Status.IN_PROGRESS) {
      status = GenericsUtils.translateI18n(
        "stats.course.students.status.inProgress"
      );
    } else if (status == Status.DONE) {
      status = GenericsUtils.translateI18n("stats.course.students.status.done");
    }
    return status;
  }

  getStatusColor(status: string): string {
    if (status == Status.INACTIVE) {
      status = "bg-h-error-100 text-h-error-800";
    } else if (status == Status.ACTIVE) {
      status = "bg-h-success-100 text-h-success-500";
    } else if (status == Status.IN_PROGRESS) {
      status = "bg-h-primary-100 text-h-primary-500";
    } else if (status == Status.DONE) {
      status = "bg-h-success-100 text-h-success-500";
    }
    return status;
  }

  remakeObjectStatus(item: any): any {
    var status = { name: "", class: "", value: "" };
    status.name = this.getStatus(item);
    status.class = this.getStatusColor(item);
    status.value = item;
    return status;
  }
}
